import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'ui-simple-text-field',
  templateUrl: './simple-text-field.component.html',
  styleUrls: ['./simple-text-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleTextFieldComponent<T> {
  @Input() textFieldControl: FormControl<T>;
  @Input() fieldLabel: string;
  @Input() testId: string;
  @Input() inputType?: string = 'text';
  @Input() isReadOnly?: boolean;
  @Input() isUppercase?: boolean = false;
  @Input() hintText?: string;
}
